<template>
  <div v-if="isMaintenance" class="under-construction-wrapper d-flex align-items-center justify-content-center">
    <MaintenancePage/>
  </div>
  <div v-else id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import MaintenancePage from "@/components/MaintenancePage.vue";

export default {
  name: 'App',
  components: {
    MaintenancePage,
  },
  data() {
    return {
      isMaintenance: true
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    }
  },
  created() {
    this.checkAccess();
  },
  methods: {
    checkAccess() {
      if (this.isMaintenance) {
        const testerCookie = Cookies.get('tester');
        if (testerCookie === 'ft123!') {
          this.isMaintenance = false;
        }
      }
    }
  }
}
</script>

<style></style>
